import { AlertBanner } from 'components/shared/AlertBanner/AlertBanner';
import { useAppSelector } from 'hooks/useAppSelector';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getWorkspaceStaticTabAiGeneratedFields } from 'state/selectors';

type Props = {
  formId: string;
};

export function SmartQuoteWarning({ formId }: Props) {
  const [isVisible, setIsVisible] = useState(true);
  const aiGeneratedFields = useAppSelector(state => getWorkspaceStaticTabAiGeneratedFields(state, formId));
  const hasSmartQuote = aiGeneratedFields !== undefined && aiGeneratedFields.length > 0;
  return (
    isVisible &&
    hasSmartQuote && (
      <AlertBanner
        color="filling-info"
        btnColor="info"
        dismissible={true}
        data-e2e="smart-quote-warning"
        onDismissed={() => setIsVisible(false)}
      >
        <FormattedMessage id="smartQuote.warning" />
      </AlertBanner>
    )
  );
}
